import type {
  HeaderHorizontalAlign,
  HeaderVerticalAlign,
} from "@gatsby-plugin-generic-page/fragments/headerAlign"

// Class maps are written out in full — Tailwind only picks up literal class
// names, so these must never be built by string interpolation.

export const HORIZONTAL_ALIGN_CLASS: Record<HeaderHorizontalAlign, string> = {
  left: "items-start text-left",
  center: "items-center text-center",
  right: "items-end text-right",
}

export const HORIZONTAL_ALIGN_MD_CLASS: Record<HeaderHorizontalAlign, string> =
  {
    left: "md:items-start md:text-left",
    center: "md:items-center md:text-center",
    right: "md:items-end md:text-right",
  }

export const HORIZONTAL_ALIGN_LG_CLASS: Record<HeaderHorizontalAlign, string> =
  {
    left: "lg:items-start lg:text-left",
    center: "lg:items-center lg:text-center",
    right: "lg:items-end lg:text-right",
  }

// Vertical alignment positions the header within the side-by-side row, so it
// only has an effect from `md` up — below that the header stacks above the
// tiles and `self-*` would fight the horizontal alignment instead.
export const VERTICAL_ALIGN_MD_CLASS: Record<HeaderVerticalAlign, string> = {
  top: "md:self-start",
  center: "md:self-center",
  bottom: "md:self-end",
}

export const VERTICAL_ALIGN_LG_CLASS: Record<HeaderVerticalAlign, string> = {
  top: "lg:self-start",
  center: "lg:self-center",
  bottom: "lg:self-end",
}

export const DEFAULT_HORIZONTAL_ALIGN: HeaderHorizontalAlign = "left"
